import type { LumpsumAllocationCategory, LumpsumAllocationSellRecommendation } from '../../../../api/allocation.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { AllocationSellFundCard } from '../cards/AllocationSellFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type AllocationSellBucketAccordionProps = {
  category: LumpsumAllocationCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function AllocationSellBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: AllocationSellBucketAccordionProps) {
  const sellRecommendations = getCategoryBucketItems<LumpsumAllocationSellRecommendation>(category?.sellRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.ALLOCATION,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.sellRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.sellRecommendations]}
      count={sellRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumAllocation,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.sellRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {sellRecommendations.map((recommendation, recommendationIndex) => (
        <AllocationSellFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          categoryName={category?.categoryName ?? ''}
          showBottomDivider={recommendationIndex < sellRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
